export const handlePreviewFont = (value: string, previewChatbot: boolean) => {
  const cleanValue = value.replace("px", "");
  const fontSize = previewChatbot
    ? `${cleanValue}px`
    : parseInt(cleanValue) / 1.2 + "px";

  return fontSize;
};

export const handleMandatoryValidation = (
  kbArticles: any,
  settings: any,
  snackbarShowMessage: any
) => {
  if (settings) {
    if (!settings?.name) {
      snackbarShowMessage(
        "Please provide a chatbot name under Text Settings",
        "error",
        3000
      );
      return false;
    }
    if (!settings?.welcomeMsg) {
      snackbarShowMessage(
        "Please provide a welcome message under Text Settings",
        "error",
        3000
      );
      return false;
    }
    if (!settings?.chatbotIcon) {
      snackbarShowMessage(
        "Please upload Bot Image under Text Settings",
        "error",
        3000
      );
      return false;
    }
    if (!settings?.sendIcon) {
      snackbarShowMessage(
        "Please upload Send Button Image under Text Settings",
        "error",
        3000
      );
      return false;
    }
    if (!settings?.chatIcon) {
      snackbarShowMessage(
        "Please upload Bottom Chat Button Image under Text Settings",
        "error",
        3000
      );
      return false;
    }
  }

  if (settings?.aiSetting) {
    if (!settings?.aiSetting?.tone) {
      snackbarShowMessage("Please select tone", "error", 3000);
      return false;
    }
    if (!settings?.aiSetting?.lengthOfResponse) {
      snackbarShowMessage(
        "Please provide the Approximate length of bots response under AI Settings",
        "error",
        3000
      );
      return false;
    }
    if (settings?.aiSetting?.lengthOfResponse < 50) {
      snackbarShowMessage(
        "Length of the response must be greater than equal to 50",
        "error",
        3000
      );
      return false;
    }
    if (settings?.aiSetting?.lengthOfResponse > 500) {
      snackbarShowMessage(
        "Length of the response must be less than or equal to 500",
        "error",
        3000
      );
      return false;
    }

    if (settings?.aiSetting?.numberOfTriesBeforeRedirect < 0) {
      snackbarShowMessage(
        "Number of tries before redirect must be greater than or equal to 0 under AI Settings",
        "error",
        3000
      );
      return false;
    }
    if (
      settings.aiSetting.numberOfTriesBeforeRedirect >= 1 &&
      (settings.aiSetting.customerSupportResponse == "" ||
        !settings.aiSetting.customerSupportResponse)
    ) {
      snackbarShowMessage(
        "Please provide custom chatbot response before redirection under the AI Settings",
        "error",
        3000
      );
      return false;
    }

    if (
      !settings?.aiSetting?.allowGeneralQuestions &&
      kbArticles?.length > 0 &&
      (!settings?.aiSetting?.kbArticles || settings?.kbArticles?.length <= 0)
    ) {
      snackbarShowMessage(
        "Please select either knowledgebase from dropdown or check bot will answer questions not related to knowledgebase or both",
        "error",
        3000
      );
      return false;
    }

    if (
      !settings?.aiSetting?.allowGeneralQuestions &&
      kbArticles?.length <= 0
    ) {
      snackbarShowMessage(
        "Please select bot will answer questions not related to knowledgebase under the AI Settings",
        "error",
        3000
      );
      return false;
    }

    if (!settings.aiSetting.openaiKey) {
      snackbarShowMessage(
        "Please provide a valid ChatGPT API key under the AI Settings",
        "error",
        3000
      );
      return false;
    }
  }

  if (
    Array.isArray(settings?.aiSetting?.intelligenceLayer) &&
    settings?.aiSetting?.intelligenceLayer?.length > 0
  ) {
    let flag = false;
    const intelligenceLayers = settings.aiSetting.intelligenceLayer;
    for (const intelligenceLayer of intelligenceLayers) {
      if (
        intelligenceLayer["question"]?.length != 0 &&
        intelligenceLayer["answer"]?.length != 0
      ) {
      } else if (
        intelligenceLayer["question"]?.length == 0 ||
        intelligenceLayer["answer"]?.length == 0
      ) {
        flag = true;
      }
    }
    if (flag) {
      snackbarShowMessage(
        "Custom question/answer under Pre AI Settings cannot be blank",
        "error",
        3000
      );
      return false;
    }
  }

  if (!settings?.branding?.["cuvo-chatbot-header-bg-color"]) {
    snackbarShowMessage(
      "Please select a primary color under Theme and Branding",
      "error",
      3000
    );
    return false;
  }
  if (!settings?.branding?.["cuvo-chatbot-bot-action-text-color"]) {
    snackbarShowMessage(
      "Please select an action color under Theme and Branding",
      "error",
      3000
    );
    return false;
  }
  if (!settings?.branding?.["cuvo-chatbot-bot-bg-color"]) {
    snackbarShowMessage(
      "Please select a chatbot message color under Theme and Branding",
      "error",
      3000
    );
    return false;
  }

  return true;
};

//KEEPING THIS FOR REFERENCE ON WHAT TO BE CHECKED.

// function mandatoryCheck(): boolean {
//   if (
//     product &&
//     product.products &&
//     product.products[0] &&
//     product.products[0].chatAgentSettings
//   ) {
//     if (!product.products[0].chatAgentSettings.name) {
//       snackbarShowMessage("You must provide chatbot name", "error", 3000);
//       // const updatedValue = { productNameErr: "You must provide chatbot name" };
//       return false;
//     }
//     if (!product.products[0].chatAgentSettings.welcomeMsg) {
//       snackbarShowMessage("You must provide welcome message", "error", 3000);
//       return false;
//     }
//     if (!product.products[0].chatAgentSettings.chatbotIcon) {
//       snackbarShowMessage("You must upload chatbot Icon", "error", 3000);
//       // const updatedValue = { productNameErr: "You must provide chatbot name" };
//       return false;
//     }
//     if (!product.products[0].chatAgentSettings.sendIcon) {
//       snackbarShowMessage("You must upload send Icon", "error", 3000);
//       // const updatedValue = { productNameErr: "You must provide chatbot name" };
//       return false;
//     }
//     if (!product.products[0].chatAgentSettings.chatIcon) {
//       snackbarShowMessage("You must upload chat Icon", "error", 3000);
//       // const updatedValue = { productNameErr: "You must provide chatbot name" };
//       return false;
//     }
//   }
//   if (
//     product &&
//     product.products &&
//     product.products[0] &&
//     product.products[0].chatAgentSettings &&
//     product.products[0].chatAgentSettings.aiSetting
//   ) {
//     if (!product.products[0].chatAgentSettings.aiSetting.tone) {
//       snackbarShowMessage("You must provide tone", "error", 3000);
//       return false;
//     }
//     if (!product.products[0].chatAgentSettings.aiSetting.lengthOfResponse) {
//       snackbarShowMessage(
//         "You must provide length of the response",
//         "error",
//         3000
//       );
//       return false;
//     }
//     if (
//       product.products[0].chatAgentSettings.aiSetting.lengthOfResponse &&
//       product.products[0].chatAgentSettings.aiSetting.lengthOfResponse < 50
//     ) {
//       snackbarShowMessage(
//         "Length of the response must be greater than equal to 50",
//         "error",
//         3000
//       );
//       return false;
//     }
//     if (
//       product.products[0].chatAgentSettings.aiSetting.lengthOfResponse &&
//       product.products[0].chatAgentSettings.aiSetting.lengthOfResponse > 500
//     ) {
//       snackbarShowMessage(
//         "Length of the response must be less than or equal to 500",
//         "error",
//         3000
//       );
//       return false;
//     }
//     // if(!product.products[0].chatAgentSettings.aiSetting.numberOfTriesBeforeRedirect) {
//     //   snackbarShowMessage(
//     //     "You must provide the number of tries before redirect",
//     //     "error",
//     //     3000
//     //   );
//     //   return false;
//     // }
//     if (
//       product.products[0].chatAgentSettings.aiSetting
//         .numberOfTriesBeforeRedirect &&
//       product.products[0].chatAgentSettings.aiSetting
//         .numberOfTriesBeforeRedirect < 0
//     ) {
//       snackbarShowMessage(
//         "Number of tries before redirect must be greater than 0",
//         "error",
//         3000
//       );
//       return false;
//     }
//     if (
//       product.products[0].chatAgentSettings.aiSetting
//         .numberOfTriesBeforeRedirect &&
//       product.products[0].chatAgentSettings.aiSetting
//         .numberOfTriesBeforeRedirect >= 1 &&
//       !product.products[0].chatAgentSettings.aiSetting.customerSupportResponse
//     ) {
//       snackbarShowMessage(
//         "You must provide custom support response",
//         "error",
//         3000
//       );
//       return false;
//     }

//     if (
//       !product.products[0].chatAgentSettings.aiSetting
//         .allowGeneralQuestions &&
//       kbArticles.length > 0 &&
//       (!product.products[0].chatAgentSettings.aiSetting.kbArticles ||
//         (product.products[0].chatAgentSettings.aiSetting.kbArticles &&
//           product.products[0].chatAgentSettings.aiSetting.kbArticles.length <=
//             0))
//     ) {
//       snackbarShowMessage(
//         "You must either select knowledgebase from dropdown or check bot will answer questions not related to knowledgebase or both",
//         "error",
//         3000
//       );
//       return false;
//     }

//     if (
//       !product.products[0].chatAgentSettings.aiSetting
//         .allowGeneralQuestions &&
//       kbArticles.length <= 0
//     ) {
//       snackbarShowMessage(
//         "You must check bot will answer questions not related to knowledgebase",
//         "error",
//         3000
//       );
//       return false;
//     }
//   }

//   if (
//     product &&
//     product.products &&
//     product.products[0] &&
//     product.products[0].chatAgentSettings &&
//     product.products[0].chatAgentSettings.aiSetting &&
//     product.products[0].chatAgentSettings.aiSetting.intelligenceLayer
//   ) {
//     if (
//       product.products[0].chatAgentSettings.aiSetting.intelligenceLayer
//         .length > 0
//     ) {
//       let flag = false;
//       const intelligenceLayers =
//         product.products[0].chatAgentSettings.aiSetting.intelligenceLayer;
//       for (const intelligenceLayer of intelligenceLayers) {
//         if (
//           intelligenceLayer["question"]?.length != 0 &&
//           // intelligenceLayer["description"]?.length != 0 &&
//           intelligenceLayer["answer"]?.length != 0
//         ) {
//         } else if (
//           intelligenceLayer["question"]?.length == 0 ||
//           // intelligenceLayer["description"]?.length == 0 ||
//           intelligenceLayer["answer"]?.length == 0
//         ) {
//           flag = true;
//         }
//       }
//       if (flag) {
//         snackbarShowMessage(
//           "You must provide question and answer for every intelligence layer",
//           "error",
//           3000
//         );
//         return false;
//       }
//     }
//   }
//   return true;
// }
